import { type FocusEvent } from 'react';
import { type Control, Controller, type FieldErrors } from 'react-hook-form';

import { type CardOptionType, useValidate } from 'hooks';
import { type PaymentType } from 'types';

import type { InputTypePropTypes } from '../input-type';

import type { InputPropTypes, CardFieldsType } from './type';

type Props = {
  control: Control<CardFieldsType, any>;
  selectedCard: CardOptionType;
  paymentData: PaymentType;
  amount: string;
  errors: FieldErrors<CardFieldsType>;
  onHandleFocus: (e: FocusEvent<HTMLInputElement>) => void;
  InputComponent: React.ForwardRefExoticComponent<
    InputPropTypes & InputTypePropTypes & React.RefAttributes<HTMLInputElement>
  >;
};

const DateInput = ({
  control,
  selectedCard,
  paymentData,
  amount,
  errors,
  InputComponent,
  onHandleFocus,
}: Props) => {
  const { validateCardMoth, validateCardYear } = useValidate();

  return (
    <div className="relative">
      <div className="flex gap-3 lg:mt-0">
        <Controller
          name="month"
          control={control}
          rules={
            selectedCard.newCard
              ? {
                  required: true,
                  validate: validateCardMoth,
                }
              : undefined
          }
          render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
            <InputComponent
              name="month"
              placeholder="MM"
              mask=" "
              format={selectedCard.newCard ? '##' : '**'}
              inputClassName="w-16 md:w-[78px] text-center"
              value={value}
              allowEmptyFormatting={!selectedCard.newCard}
              onChange={onChange}
              onFocus={onHandleFocus}
              ref={ref}
              type="tel"
              disabled={paymentData.commission > amount || !selectedCard.newCard}
              error={!!error?.message}
            />
          )}
        />
        <Controller
          name="year"
          control={control}
          rules={
            selectedCard.newCard
              ? {
                  required: true,
                  validate: validateCardYear,
                }
              : undefined
          }
          render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
            <InputComponent
              name="year"
              placeholder="YY"
              mask=" "
              format={selectedCard.newCard ? '##' : '**'}
              inputClassName="w-16 md:w-[78px] text-center"
              value={value}
              onChange={onChange}
              onFocus={onHandleFocus}
              ref={ref}
              type="tel"
              allowEmptyFormatting={!selectedCard.newCard}
              disabled={paymentData.commission > amount || !selectedCard.newCard}
              error={!!error?.message}
            />
          )}
        />
      </div>
      {(errors.year ?? errors.month) && (
        <span className="text-1xbet-red text-[11px] leading-3 text-left mt-[3px] lowercase whitespace-nowrap absolute">
          {errors.year?.message ?? errors.month?.message}
        </span>
      )}
    </div>
  );
};

export { DateInput };
